import React from 'react';
import {FormField, Select} from '@amzn/awsui-components-react';

interface ForecastSelectorProps {
    selectedForecastId: string;
    availableForecastIds: {label: string; value: string}[];
    onForecastChange: (forecastId: string) => void;
}

export default function ForecastSelector({selectedForecastId, availableForecastIds, onForecastChange}: ForecastSelectorProps) {
    return (
        <FormField label="Forecast By Creation Time">
            <Select
                selectedOption={availableForecastIds.find((f) => f.value === selectedForecastId) || null}
                onChange={({detail}) => onForecastChange(detail.selectedOption.value || '')}
                options={availableForecastIds}
                placeholder="Select forecast By Creation Time"
            />
        </FormField>
    );
}
